// extracted by mini-css-extract-plugin
module.exports = {"container":"NoBotMessage_container__2V34k","btn":"NoBotMessage_btn__2dnqq"};